<!--详情发货选择物流-->
<!--选择完以后要调用此组件的getData函数获取选中的物流信息 -->
<!-- subid 必传  需要查是否是首次购买 -->
<template>
  <div :class="status == 'WAIT_SEND' ? 'div-b' :'newdiv-b'">
    <p class="dtips" v-show="defaultInfo.isFreeShippingCn">温馨提示:此订单为到付订单，发货时请与快递核对确认发货方式为到付!</p>
    <div>
      <div class="title">
        <div class="title-head">
          <div class="left">物流信息<span>平台推荐用快递码</span></div>
          <div v-if="status == 'WAIT_SEND'" class="right" @click.stop="showArrow" > {{!isArrow ? '收起' :'展开'}}<van-icon :name=" !isArrow ? 'arrow-down': 'arrow-up'" /></div>
        </div>
        <div class="title-info">
            手动发货时，请核对发货物流单号上的收件人信息，填入正确的单号，以免用户查看物流轨迹信息时产生疑惑
        </div>
        <span class="rig" v-if="status == 'WAIT_RECEIVING'" @click="lookPressFun">
          物流信息
          <van-icon
            style="vertical-align: middle;"
            class="icon"
            name="arrow"
            size="16px"
            color="#F8A651"
          />
        </span>
      </div>
      <van-field
        v-if="status == 'WAIT_SEND'"
        readonly
        required
        clickable
        name="picker"
        :value="companyName"
        label="物流公司"
        placeholder="点击选择 >"
        @click.stop="showPicker = true"
        input-align="right"
      /> 
      <van-field
        v-else
        required
        readonly
        v-model="defaultInfo.expressName"
        label="物流公司"
        input-align="right"
      />
      <van-field class="border" required v-if="status == 'WAIT_SEND'" v-model="wcode" label="物流单号" input-align="right" />
      <van-field class="border" required v-else readonly v-model="defaultInfo.wayBillCode" label="物流单号" input-align="right" />
      <van-field class="border"  v-if="companyName ==='顺丰快递'" v-model="sendMobile" label="寄件人手机" input-align="right" />
      <div class="bottom-right-copy" v-if="companyName ==='顺丰快递'">上次使用的手机号：{{lastsendMobile}} <span class="bottom-right-button" @click="sendMobile=lastsendMobile">自动填写</span> </div>
      <div class="bottom-info"  v-if="companyName ==='顺丰快递'">
        注意：请确认寄件人手机号与真实物流单号上的保持一致，否则可能无法获取到本订单的物流发货轨迹。
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        title="物流公司"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      >
      <!-- <div slot="title" class="picker-title title-head"> -->
        <!-- <div class="left"><span></span></div> -->
        <!-- <div class="right" @click="onJumpToHelpCenterDetail"><span>操作指引 ></span></div> -->
      <!-- </div> -->
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  props: {
    subid: {
      type: [Number,String],
      default: 0,
      required: true
    },
    status: {
      type: String,
      default: "",
      required: false
    },
    defaultInfo: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    }
  },
  watch: {
    subid: function(val, oldV) {
      this.isFirstSubOrder(val);
    }
  },
  data() {
    return {
      value: "",
      companyName: "",
      expressType: "",
      expressId: "",
      wcode: "",
      columns: [],
      columnsForm1: {},
      columnsForm2: {},
      columnsForm3: {},
      showPicker: false,
      sendMobile:'',
      isArrow:false,
      lastsendMobile:''
    };
  },
  methods: {
    getFright() {
      http({
        url: "shop/shop/fright/list",
        method: "GET"
      }).then(rps => {
        this.columns = rps.data.map(item => {
          return item.companyName;
        });
        rps.data.forEach(element => {
          this.columnsForm1[element.companyName] = element.expressType;
          this.columnsForm2[element.companyName] = element.id;
          this.columnsForm3[element.expressType] = element.companyName;
          if(element.expressType ==='SF'){
            this.lastsendMobile = element.lastSendMobile
          }
        });
      });
    },
    onConfirm(tab) {
      if (tab) {
        this.companyName = tab;
        this.expressType = this.columnsForm1[tab];
        this.expressId = this.columnsForm2[tab];
        this.showPicker = false;
      }
    },
    isFirstSubOrder(val) {
      http({
        url: "order/admin/isFirstBySubOrderId/" + val,
        method: "GET"
      }).then(rps => {
        this.value = (rps.data && "温馨提示：该订单是新用户首单交易") || "";
      });
    },
    getData() {
      if (!this.expressType) {
        Toast("请选择物流");
        return "";
      }
      let $code = this.wcode;
      if (!$code.replace(/\s/g, "")) {
        Toast("请填写物流单号");
        return "";
      }
      if ($code.replace(/\s/g, "").length < 10) {
        Toast("物流单号不能少于10位");
        return "";
      }
      if(this.expressType ==='SF' && !this.sendMobile){
        Toast('顺丰物流需要填写寄件人手机')
        return 
      }
      let parmes = {
        companyName: this.companyName,
        expressType: this.expressType,
        expressId: this.expressId,
        wcode: this.wcode,
        sendMobile:this.sendMobile
      }
      if(this.expressType !== 'SF'){
        delete parmes.sendMobile
      }
      return parmes

    },
    lookPressFun(){
      this.$store.dispatch('setExpressObjData',{
        payTime: this.defaultInfo.createTime,
        subOrderCode: this.defaultInfo.subOrderCode,
        imgUrl:  (this.defaultInfo.appSubOrderItemDetailVoList || []).length ? this.defaultInfo.appSubOrderItemDetailVoList[0].skuImageInfoUrlList[0] : ''
      })
      let query = {
        subid: this.subid
      }
      if(this.$router.query.role ==='bees'){
        query.role = 'bees',
        query.dispatchType =this.defaultInfo.dispatchType
      }
      this.$router.push({name: "userExpress",query: { ...query }});
    },
    onJumpToHelpCenterDetail() {
      /**
       * 跳转帮助中心-快递码怎么使用？
       */
      utils.jumpToNewPage({
        url:
          window.location.origin +
          "/h5user/helpcenter_Details?id=79",
        noTitle: "0",
      });
    },
    showArrow(){
      this.isArrow = !this.isArrow;
      this.$emit('isArrow',this.isArrow)
    }
  },
  created() {
    this.getFright();
  },
  components: {}
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.border::after{
  border-bottom:1px solid #ebedf0 ;
}
.div-b {
  font-size: 0.4rem;
  border-radius: 0.15rem;
  background-color: #fff;
  text-align: center;
  position: relative;
  border-radius: 20px 20px 0 0;
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  // padding: 0 30px;
  overflow: hidden;
  .title{
    display: block;
    text-align: left;
    font-size: 36px;
    color: #3B3A38;
    font-weight: 500;
    padding: 28px 30px 0;
    clear: both;
    .rig{
      font-size: 24px;
      color: #F08E3C;
      float: right;
      font-weight: 500;
    }
  }
  .title-info{
    font-size: 24px;
    color: #898887;
    background: #F6F6F6;
    border-radius: 10px;
    padding: 10px 10px;
    margin-top: 10px;
    line-height: 40px;
  }
  .title-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .left {
      flex: 1;
      span {
        font-size: 24px;
        color: #999;
        font-weight: normal;
        color: #F8A651;
        padding-left: 8px;
      }
    }
    .right{
      font-size: 24px;
      font-weight: 400;
      color: #B4B4B4;
    }
    span {
      font-size: 24px;
      color: #999;
      font-weight: normal;
      color: #F8A651;
    }
  }
  .dtips{
    font-size: 20px;
    color: #F8A651;
    margin-left: -30px;
    text-align: center;
  }
}

.newdiv-b {
  font-size: 0.4rem;
  border-radius: 0.15rem;
  background-color: #fff;
  text-align: center;
  position: relative;
  border-radius: 10px;
 
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  margin: 0 38px 30px 38px;
  // margin-bottom: 50px;
  overflow: hidden;
  .title{
    display: block;
    text-align: left;
    font-size: 28px;
    color: #333333;
    font-weight: bolder;
    padding: 28px 30px 0;
    clear: both;
    .rig{
      font-size: 24px;
      color: #F8A651;
      float: right;
      font-weight: 500;
    }
  }
  .title-head {
    display: flex;
    align-items: center;
    .left {
      flex: 1;
      span {
        padding-left: 10px;
      }
    }
    span {
      font-size: 24px;
      color: #999;
      font-weight: normal;
      // color: tomato;
      color: #F8A651;
    }
  }
  .dtips{
    font-size: 20px;
    color: #F8A651;
    // margin-left: -30px;
    text-align: center;
  }
}

.mt-5 {
  margin-bottom: 0.2rem;
}
.picker-title {
  flex: 1;
  .left {
    text-align: left;
  }
}
.bottom-info{
  font-size: 24px;
  color: #E15554;
  line-height: 36px;
  background: #FDF2F2;
  border-radius: 8px;
  border: 1px solid #E15554;
  padding: 24px;
  box-sizing: border-box;
  margin: 24px;
  text-align: left;
}
.bottom-right-copy{
  color: #898887;
  margin: 24px;
  font-size: 24px;
  text-align: right;
  .bottom-right-button{
    width: 112px;
    height: 34px;
    background: #FFD102;
    border-radius: 4px;
    font-size: 22px;
    color: #3B3A38;
    padding: 2px 5px;
    box-sizing: border-box;
  }
}
//#F8A651
</style>